/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDRequestMetadata } from './IDRequestMetadata';
import {
    IDRequestMetadataFromJSON,
    IDRequestMetadataFromJSONTyped,
    IDRequestMetadataToJSON,
    IDRequestMetadataToJSONTyped,
} from './IDRequestMetadata';

/**
 * 
 * @export
 * @interface PostTokenRequestV2
 */
export interface PostTokenRequestV2 {
    /**
     * 
     * @type {IDRequestMetadata}
     * @memberof PostTokenRequestV2
     */
    metadata: IDRequestMetadata;
}

/**
 * Check if a given object implements the PostTokenRequestV2 interface.
 */
export function instanceOfPostTokenRequestV2(value: object): value is PostTokenRequestV2 {
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function PostTokenRequestV2FromJSON(json: any): PostTokenRequestV2 {
    return PostTokenRequestV2FromJSONTyped(json, false);
}

export function PostTokenRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PostTokenRequestV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'metadata': IDRequestMetadataFromJSON(json['metadata']),
    };
}

export function PostTokenRequestV2ToJSON(json: any): PostTokenRequestV2 {
    return PostTokenRequestV2ToJSONTyped(json, false);
}

export function PostTokenRequestV2ToJSONTyped(value?: PostTokenRequestV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metadata': IDRequestMetadataToJSON(value['metadata']),
    };
}

